(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-comparison"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-log-comparison]').forEach((section)=>{const range=section.querySelector('[data-log-comparison-range]');const after=section.querySelector('[data-log-comparison-after]');if(!range||!after||range.dataset.initialized==='true')return;const update=()=>{after.style.width=range.value+'%'};range.addEventListener('input',update);range.dataset.initialized='true';update()});

  } catch(e) { console.error(e); }
})();
})();
